<template>
  <v-row>
    <v-col>
      <v-snackbar v-model="errorLoading" color="error" :top="true"
        >An error occurred while loading data</v-snackbar
      >
      <v-snackbar v-model="errorOperation" color="error" :top="true"
        >An error occurred during the server communication</v-snackbar
      >
    </v-col>
  </v-row>
</template>

<script>
export default {
  data() {
    return {};
  },
  computed: {
    errorLoading: {
      get() {
        return this.$store.state.app.errorLoading;
      },
      set(value) {
        this.$store.commit("app/SET_ERROR_LOADING", value);
      },
    },
    errorOperation: {
      get() {
        return this.$store.state.app.errorOperation;
      },
      set(value) {
        this.$store.commit("app/SET_ERROR_OPERATION", value);
      },
    },
  },
};
</script>
